import { RecoilRoot } from "recoil";
import Router from "./Router";
import GlobalStyle from "./styles/GlobalStyles";
import InitRecoil from "./recoil/InitRecoil";
import { CacheBuster, Meta } from "./components";
import { ModalProvider } from "./context/ModalContext";
import { useOnPageVisible } from "./hooks";
import { Fragment, useState } from "react";

function App() {
  return (
    <>
      <Meta />
      <CacheBuster>
        <RecoilRoot>
          <ModalProvider>
            <GlobalStyle />
            <ReFocusController>
              <InitRecoil />
            </ReFocusController>
            <Router />
          </ModalProvider>
        </RecoilRoot>
      </CacheBuster>
    </>
  );
}

export default App;

const ReFocusController = (props: any) => {
  const [bool, setBool] = useState(true);
  useOnPageVisible(() => {
    setBool((b) => !b);
  });

  return <>{<Fragment key={`${Date.now()}-${bool}`}>{props.children}</Fragment>}</>;
};
